<template>
  <div class="image-slider">
    <v-touch @swipeleft="swipeNext" @swiperight="swipePrev">
      <div class="image-wrapper">

        <div class="" v-for="(image, key) in computedImages">
          <!--<div v-if="image.hasOwnProperty('type') && key === currentNumber && show">
            <div class="video">
              <p>Video {{image.index}}</p>
              &lt;!&ndash;<video src="image.url"></video>&ndash;&gt;
            </div>
          </div>
          <div v-else>
          </div>-->
          <transition
            :enter-active-class="transitionNext"
            :leave-active-class="transitionPrev"
            mode="out-in" appear
          >
            <div class="image"
                 :style="{ 'background-image': 'url(' + image + ')', 'background-size': backgroundSize}"
                 style="background-repeat: no-repeat; background-position: center;"
                 v-show="key === currentNumber && show" key="key"></div>
<!--            <img class="image" :src="image" alt="" v-show="key === currentNumber && show" :key="key">-->
          </transition>
        </div>

        <div class="vue-preload-image" v-if="!show">
          <div class="progress">
            <slot name="loader"></slot>
            <p class="tip-str" v-if="tipStrShow">{{tipStr}}</p>
            <!--<p class="progress-str" v-if="progressShow">{{progressStr}}</p>-->
          </div>
        </div>

      </div>

    </v-touch>
  </div>
</template>

<script>
  import eventHub from '@/plugins/EventHub'
  import preloader from '@/mixins/preloader'

  export default {
    name: "image-slider",
    props: {
      slides: {
        type: Array,
        required: true,
      },
      transitionType: {
        type: String,
        default: 'fade'
      },
      backgroundSize: {
        type: String,
        default: 'cover'
      },
      auto: {
        type: Boolean,
        default: false
      },
      tipStrShow: {
        type: Boolean,
        default: true,
      },
      tipStr: {
        type: String,
        default: 'loading...'
      }
    },
    components: {},
    data() {
      return {
        currentNumber: 0,
        timer: null,
        interval: 3000,
        isPaused: false,
        show: false,
        progressStr: '',
        imgsSum: NaN,
        tempArr: [],
        loadedCount: 0,
        tempImages: [],
        images: [],
        debug: false,
        transitionNext: 'animated fadeInLeft',
        transitionPrev: 'animated fadeOutRight',
      }
    },
    mixins: [
      preloader
    ],
    created() {


    },
    mounted() {
      this.init();
      eventHub.$on('next', this.callNext);
      eventHub.$on('prev', this.callPrev);
      eventHub.$on('togglePlay', this.togglePlay);
      eventHub.$on('selectImage', (imageId) => {
        this.selectImage(imageId);
      });
      window.addEventListener('keyup', this.setKeyboard);
      /*eventHub.$on('load-slides', () => {
        console.log('load-slides');
        // this.init();
      });*/
      // this.togglePlay();
    },
    computed: {
      computedImages: function () {
        return this.images;
      }

    },
    watch: {
      slides: function (newVal, oldVal) {
        if (this.debug) console.log('Prop changed: ', newVal, ' | was: ', oldVal);
        this.init();
      }
    },
    methods: {
      init() {
        this.resetImages();
        this.checkImages();
      },
      resetImages() {
        this.show = false;
        for (let i = 0; i < this.tempArr.length; i++) {
          this.tempArr[i].removeEventListener('load', this.imagesLoaded);
        }
        this.tempArr = [];
        this.images.splice(0);
        this.loadedCount = 0;
        this.currentNumber = 0;
        this.stopRotation();
      },

      checkImages() {
        let tempSlides = [];
        this.slides.forEach((slide) => {
          if (slide.type) {
            console.log(slide);
            this.tempImages.push(slide);
          } else {
            this.tempImages.push(slide);
            tempSlides.push(slide);
          }
        });
        this.preloadImages(tempSlides, this.imagesReady);
      },

      imagesReady(tempArr) {
        // Once all images are loaded the tempArr replaces the images array
        this.images = this.tempImages;

        this.show = true;
        if (this.auto === true) this.startRotation();

        // console.log('ready')
        // if (this.debug) console.log('pages ', this.pages);
        // if (this.debug) console.log(this.loadedSet);
        // if (this.debug) console.log('ImagesPaged: ', this.imagesPaged);
        // if (this.debug) console.log('ImagesPaged[0]: ', this.imagesPaged[ 0 ]);
        // if (this.debug) console.log(this.computedImages % this.pages);
        // if (this.debug) console.log('Groups ', this.createGroupedArray(this.images, this.pageSet));

      },

      //Play Functions
      startRotation: function () {
        if (this.isPaused === true) {
          this.isPaused = false;
          this.next();
        }
        this.timer = setInterval(this.next, this.interval);
        if (this.debug) console.info('Slider PLAYING');
        eventHub.$emit('play');
      },

      stopRotation: function () {
        clearTimeout(this.timer);
        this.timer = null;
        if (this.isPaused === false && this.debug) console.info('Slider PAUSED');
        this.isPaused = true;
        eventHub.$emit('pause');
      },
      next: function () {
        if (this.debug) console.log('Current Number: ', this.currentNumber);

        if (this.currentNumber < this.images.length - 1) {
          this.currentNumber += 1;
          // this.$store.dispatch('selectImageId', this.currentNumber);
        } else {
          this.currentNumber = 0;
        }

        // this.$store.dispatch('selectImageId', this.currentNumber);
      },
      prev: function () {
        if (this.currentNumber > 0) {
          this.currentNumber -= 1
        } else {
          this.currentNumber = this.images.length - 1;
        }

        // this.$store.dispatch('selectImageId', this.currentNumber);
      },
      callNext: function () {
        this.stopRotation();
        this.transitionNext = 'animated fadeInRight';
        this.transitionPrev = 'animated fadeOutLeft';
        this.next();
        if (this.isPaused === false) {
          this.isPaused = true;
          eventHub.$emit('pause');
        }
      },
      callPrev: function () {
        this.stopRotation();
        this.transitionNext = 'animated fadeInLeft';
        this.transitionPrev = 'animated fadeOutRight';

        this.prev();
        if (this.isPaused === false) {
          this.isPaused = true;
          eventHub.$emit('pause');
        }
      },
      swipeNext() {
        eventHub.$emit('next');
      },
      swipePrev() {
        eventHub.$emit('prev');
      },
      togglePlay: function () {
        if (this.debug) console.log('toggled');
        this.isPaused ? this.startRotation() : this.stopRotation();
      },
      //Select Image
      selectImage: function (imageId) {
        this.stopRotation();
        this.currentNumber = imageId;
      },
      setKeyboard(e) {
        // if (this.debug) console.log(e.keyCode);
        if (e.keyCode === 39) eventHub.$emit('next');
        if (e.keyCode === 37) eventHub.$emit('prev');
      },
    },
    beforeDestroy: function () {
      window.removeEventListener('keyup', this.setKeyboard);
    },
  }

</script>

<style scoped lang="scss">
  @import "./src/assets/scss/main";

  .animated {
    animation-duration: .9s;
    animation-fill-mode: both;
    /*animation-timing-function: ease-in-out;*/
    backface-visibility: hidden;
    z-index: 1;
    /*animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);*/
    animation-timing-function: cubic-bezier(0.415, 0.610, 0.355, 1.000);
    will-change: transform;
  }

  @mixin animate($name) {

  }

  $translateAmount: 30%;

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      /*-webkit-transform: translate3d(-#{$translateAmount}, 0, 0);
      transform: translateX(-#{$translateAmount}, 0, 0);*/
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInLeft {
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      /*-webkit-transform: translate3d($translateAmount, 0, 0);
      transform: translate3d($translateAmount, 0, 0);*/
    }

    to {
      opacity: 1;
      /*-webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);*/
    }
  }

  .fadeInRight {
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
  }

  @keyframes fadeOutLeft {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      /*-webkit-transform: translate3d(-#{$translateAmount}, 0, 0);
      transform: translate3d(-#{$translateAmount}, 0, 0);*/
      position: absolute;
    }
  }

  .fadeOutLeft {
    -webkit-animation-name: fadeOutLeft;
    animation-name: fadeOutLeft;
  }

  @keyframes fadeOutRight {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
     /* -webkit-transform: translate3d($translateAmount, 0, 0);
      transform: translate3d($translateAmount, 0, 0);*/
      position: absolute;
    }
  }

  .fadeOutRight {
    -webkit-animation-name: fadeOutRight;
    animation-name: fadeOutRight;
  }

  .spinner {
    position: absolute;
    left: 48%;
    /*top: calc(50vh + 20px);*/
    top: 50vh;
  }

  .fade-enter, .fade-leave {
    opacity: 0;
    visibility: hidden;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0
  }

  .image-slider {
    height: 80vh;
    margin-bottom: 1rem;
    /*max-height: calc(85vh - 90px);*/
    width: 100%;
    position: relative;
    min-height: 300px;

    @include media($mobile) {
      height: 500px;
    }

    /*@include media($tablet-up) {
      min-height: 500px;
    }

    @include media($desktop) {
      max-height: calc(80vh - 100px);
    }
    @include media($desktop1200) {
      max-height: calc(80vh - 90px);
    }
    @include media($desktop1500) {
      max-height: calc(85vh - 100px);
    }
    @include media($largePortrait) {
      max-height: calc(60vh - 90px);
     }*/
  }

  .image-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;

    div {
      /*position: absolute;*/

    }

    img, .image {
      position: absolute;
      /*position: relative;*/
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      /*box-shadow:  1px 2px 5px black;*/
      object-fit: contain;
      /*filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, .5));*/
    }

    .video {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, .5));
    }
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(.1, .65, .98, .36);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .slide-in-active {
    transition: all .5s;
  }

  .slide-out-active {
    transition: all 2.5s;
  }

  .slide-in {
    transform: translateX(10px);
  }

  .slide-out {
    transform: translateX(-30px);
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  .vue-preload-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    text-align: center;

    .progress {
      position: relative;
      display: table-cell;
      vertical-align: middle;

      p {
        margin: 0;
        color: white;
      }

      .tip-str {
        margin-bottom: .8em;
      }

      .loadingAnimation {
        width: 60px;
        height: 60px;
        background-color: #67CF22;

        margin: 0 auto;
        -webkit-animation: rotateplane 1.2s infinite ease-in-out;
        animation: rotateplane 1.2s infinite ease-in-out;
      }

      @keyframes rotateplane {
        0% {
          transform: perspective(120px) rotateX(0deg) rotateY(0deg);
        }
        50% {
          transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
        }
        100% {
          transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
        }
      }
    }
  }

</style>
